export class AppConstants {
    public static get API_URL():string { return "https://locawork-web-api-3.onrender.com"; };
}
export enum Roles {
    OWNER ="ROLE_OWNER",
    ADMIN ="ROLE_ADMIN",
    MODERATOR ="ROLE_MODERATOR",
    BASIC ="ROLE_BASIC",
    PREMIUM ="ROLE_PREMIUM",
    GOLD ="ROLE_GOLD",
    PLATINUM ="ROLE_PLATINUM"
}